<template>
  <div class="body-container import-order-list big-list">
    <van-list v-model="listLoading" :finished="finished" :finished-text="finishedText" @load="nextPage" class="list-content order-list">
      <van-cell v-for="(item, index) in list" :key="index">
        <div class="list-item" @click="goPage('/m/order/importOutsideOrderDetail',{id:item.id})">
          <div class="top-box">
            <div class="text">录入时间：{{item.createTime | timeStatus}}</div>
          </div>
          <div class="content-box">
            <div class="title">{{item.productName}}</div>
            <div class="left-box">
              <div class="text"><span class="label">投/被保人：</span>{{item.policyerName}}<span v-if="item.policyerName&&item.insuranceName">/</span>{{item.insuranceName}}</div>
              <div class="text"><span class="label">保障期限：</span>{{item.startTime|timeSplit}}至{{item|filterEndTime}}</div>
              <div class="text"><span class="label">保费：</span>{{item.fee|filterFee}}元</div>
            </div>
            <img src="@static/images/order/icon-lr.png" class="icon">
          </div>
          <div class="bottom-box">
            <van-button plain class="btn" type="info" @click.stop="del(item)">删除</van-button>
            <van-button plain class="btn active" type="info"
              @click.stop="goPage('/m/order/importOutsideOrder',{id:item.id})">编辑</van-button>
          </div>
        </div>
      </van-cell>

      <div class="null" v-if="list.length<=0&&!listLoading">
        <img class="null-img" src="@static/images/null2.png">
        <span class="null-text">暂无保单</span>
      </div>
    </van-list>
    <div class="page-bottom-box">
      <van-button class="btn" type="info" @click="goPage('/m/order/importOutsideOrder')">添加保单</van-button>
    </div>
  </div>
</template>

<script>
import {pageTools,common} from "@/api/mixins";
export default {
  mixins:[pageTools,common],
  components:{},
  data() {
    return {
      orderOrPolicy:'orderOrPolicy',
      listLoading:false,
      showSelectPanel:false,//账户类型弹窗
      type:"1",
      typeName:"全部账户",
      name: "",//投/被人姓名
      startTime:"",
      endTime:"",
      incomes:"",//服务费
      totalFee:"",//保费
      ordersNum:"",//订单数
      list:[],
    };
  },
  created(){
  },
  mounted() {
    if(!this.checkLogin()){
      return;
    }
    // 查询订单列表
    this.$weixin.hideMenu();
    this.initListAjax("/api/getMyPolicy")
  },
  methods: {
    listCallback(res){
      this.listLoading = false;
      this.list = res.data;
    },
    //设置产品参数
    setListParams(params){
      this.listLoading = true;
      params.resource = 3;

      return params
    },
    // 删除
    del(item){
      this.$notice.inquiry("确定删除保单？",["确定","取消"],()=>{
        this.$http({
          type: "PUT",
          url: "/api/bplat/delEnteryPolicy/"+item.id,
          data: {}
        }).then(res=>{
          this.$notice.msg("删除成功");
          const index = this.list.findIndex((bean)=>{
            return bean.id == item.id;
          });
          this.list.splice(index,1)
          if(this.list.length==0){
            this.finishedText = "";
          }
        });
      })
    },
  },
  filters:{
    filterEndTime(item){
      if(item.endTime=='2888-01-01 00:00:00'||item.guarateeType==1){
        return '终身'
      }else if (!item.endTime) {
        return;
      }else{
        return item.endTime.substring(0, 10).replace(/-/g,'/');
      }
    },
    filterFee(val){
      if(!val){
        return '0.00'
      }else{
        return val.toFixed(2)
      }
    }
  }

};
</script>

<style lang="scss" scoped>
@import "./importOrderList";
.import-order-list .list-content {
  padding-top: 30px;
}
</style>
